var map = {
	"./action_addSize.svg": 93029,
	"./action_bind.svg": 16779,
	"./action_changeScene.svg": 17936,
	"./action_flash.svg": 68559,
	"./action_go.svg": 37028,
	"./action_goTo.svg": 68076,
	"./action_hide.svg": 65579,
	"./action_kill.svg": 21972,
	"./action_move.svg": 43731,
	"./action_moveTo.svg": 31668,
	"./action_onCollide.svg": 9576,
	"./action_onCollideEnd.svg": 86233,
	"./action_onCollideOnce.svg": 48738,
	"./action_onFrame.svg": 74026,
	"./action_onKey.svg": 43847,
	"./action_onKeyUp.svg": 82349,
	"./action_onOut.svg": 23467,
	"./action_onOverlap.svg": 27676,
	"./action_onOverlapOnce.svg": 71146,
	"./action_onShake.svg": 37776,
	"./action_onSignal.svg": 18897,
	"./action_onSwipe.svg": 20401,
	"./action_onTouch.svg": 49283,
	"./action_onTouchUp.svg": 88066,
	"./action_pause.svg": 13221,
	"./action_pauseTimer.svg": 94437,
	"./action_play.svg": 85655,
	"./action_playAnimation.svg": 9473,
	"./action_replay.svg": 95050,
	"./action_resetTimer.svg": 67431,
	"./action_restart.svg": 55910,
	"./action_resume.svg": 6559,
	"./action_resumeTimer.svg": 80700,
	"./action_revive.svg": 43318,
	"./action_saveScore.svg": 23280,
	"./action_say.svg": 87895,
	"./action_sendSignal.svg": 18541,
	"./action_setCollision.svg": 12245,
	"./action_shake.svg": 80568,
	"./action_show.svg": 28744,
	"./action_showRanking.svg": 24958,
	"./action_showRankingAscending.svg": 62599,
	"./action_speak.svg": 87304,
	"./action_startTimer.svg": 71066,
	"./action_stop.svg": 17107,
	"./action_stopAnimation.svg": 27828,
	"./action_turn.svg": 17334,
	"./action_turnTo.svg": 2653,
	"./action_vibrate.svg": 41659,
	"./action_wait.svg": 44372
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30591;